module.exports = __webpack_public_path__ + "static/img/37.3ee47895.jpg";